module.exports = "<ng-template #someref>\n  foo bar\n</ng-template>\n\n<div\n  class=\"content-wrapper\"\n  [ngClass]=\"{'hidden':!isActive,'dirty':isDirty,'invalid':!isValid, 'centerized':position == positions.center}\"\n>\n  <div class=\"content\">\n    <div #content></div>\n    <ng-content></ng-content>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-wizard-pane/form-wizard-pane.component.html
// module id = ../../../../../src/app/modules/ui-form/components/form-wizard-pane/form-wizard-pane.component.html
// module chunks = main